/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { APP } from 'Configs/App'
import AdminPanel from 'Containers/AdminPanel'
import ArtistsAnalytics from 'Containers/AdminAnalytics/ArtistsAnalytics'
import CuratorsAnalytics from 'Containers/AdminAnalytics/CuratorsAnalytics'

import { admin, analytics, artists, curators } from './routes'
import { User } from '../Types'

type AdminProtectedProps = {
  user: User
}

const AdminProtected: React.FunctionComponent<AdminProtectedProps> = ({
  user,
}) => (
  <>
    {APP.admin_email.includes(user?.email) && (
      <Switch>
        <Route component={AdminPanel} exact path={admin} />
        <Route
          component={ArtistsAnalytics}
          exact
          path={`${analytics}${artists}`}
        />
        <Route
          component={CuratorsAnalytics}
          exact
          path={`${analytics}${curators}`}
        />
      </Switch>
    )}
  </>
)

export default AdminProtected
